import Vue from 'vue'
import Router from 'vue-router'
import Us from '@/components/Us'
import Gallery from '@/components/Gallery'
import Groom from '@/components/Groom'
import Ceremony from '@/components/Ceremony'
import Uin from '@/components/Uin'
import Gifts from '@/components/Gifts'
import Callback from '@/components/Callback'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/Us'
    },
    {
      path: '/Us',
      name: 'Us',
      component: Us
    },
    {
      path: '/Gallery',
      name: 'Gallery',
      component: Gallery
    },
    {
      path: '/Groom',
      name: 'Groom',
      component: Groom
    },
    {
      path: '/Ceremony',
      name: 'Ceremony',
      component: Ceremony
    },
    {
      path: '/Uin',
      name: 'Uin',
      component: Uin
    },
    {
      path: '/Gifts',
      name: 'Gifts',
      component: Gifts
    },
    {
      path: '/Callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '*',
      redirect: '/Us'
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js